// ==========================================================
// delivery-date-time-drawer.js
// カートドロワー（"My Cart" ポップアップ）に配送日時ウィジェットを
// 自動挿入します。theme.liquid など全ページ共通のファイルから
// 読み込んでください（ドロワーはどのページからでも開くため）。
//
// 挿入先: テーマ純正の合計金額表示 <div class="total"> の直後。
// CCアプリ自身の要素（#cc-calendar-overall など）ではなく、
// テーマ純正の要素を目印にしているため、CCアプリを将来停止しても
// 動き続けます。
//
// ドロワーの中身が再描画されて .total ごと作り直された場合も、
// MutationObserverで検知して自動的に入れ直します。
// ==========================================================
(function () {
  'use strict';

  if (!window.DDCore) { console.error('delivery-date-time-core.js が先に読み込まれている必要があります'); return; }
  var Core = window.DDCore;

  var TIME_SLOTS = ['指定しない', '午前中(8時から12時)', '12時から14時', '14時から16時', '16時から18時', '18時から20時', '18時から21時', '19時から21時'];
  // 挿入先の目印。実際のDOM調査で total は
  // form.js-cart-form > div.ajax-cart_summary-wrapper > div.ajax-cart_final-details > div.total
  // という構造だと確認できたため、ajax-cart_final-details 配下の .total に絞り込み、
  // サイト内の無関係な .total に誤って挿入しないようにしています。
  // 万一この構造が変わっていた場合のフォールバックとして、素の .total も試します。
  var ANCHOR_SELECTORS = ['.ajax-cart_final-details .total', '.total'];

  function findAnchors() {
    for (var i = 0; i < ANCHOR_SELECTORS.length; i++) {
      var found = document.querySelectorAll(ANCHOR_SELECTORS[i]);
      if (found.length) return found;
    }
    return [];
  }

  function buildWidgetShell() {
    var wrap = document.createElement('div');
    wrap.className = 'dd-picker dd-picker--drawer';
    wrap.style.cssText = 'display:block !important; width:100% !important;';

    var title = document.createElement('h3');
    title.className = 'dd-picker__title';
    title.style.cssText = 'display:block !important;';
    title.textContent = '配送日時のご指定';
    wrap.appendChild(title);

    // 都道府県
    var prefField = document.createElement('div');
    prefField.className = 'dd-picker__field';
    prefField.style.cssText = 'display:flex !important; flex-direction:column !important; width:100% !important;';
    var prefLabel = document.createElement('label');
    prefLabel.textContent = 'お届け先の都道府県';
    var prefSelect = document.createElement('select');
    prefSelect.className = 'dd-drawer-pref';
    var prefBlank = document.createElement('option');
    prefBlank.value = '';
    prefBlank.textContent = '選択してください';
    prefSelect.appendChild(prefBlank);
    Core.PREFECTURE_GROUPS.forEach(function (group) {
      var optgroup = document.createElement('optgroup');
      optgroup.label = group[0];
      group[1].forEach(function (pref) {
        var opt = document.createElement('option');
        opt.value = pref;
        opt.textContent = pref;
        optgroup.appendChild(opt);
      });
      prefSelect.appendChild(optgroup);
    });
    prefField.appendChild(prefLabel);
    prefField.appendChild(prefSelect);
    wrap.appendChild(prefField);

    // 日付
    var dateField = document.createElement('div');
    dateField.className = 'dd-picker__field';
    dateField.style.cssText = 'display:flex !important; flex-direction:column !important; width:100% !important;';
    var dateLabel = document.createElement('label');
    dateLabel.textContent = '配送希望日';
    var chipsWrap = document.createElement('div');
    chipsWrap.className = 'dd-chips dd-drawer-chips';
    chipsWrap.style.cssText = 'display:flex !important; flex-direction:row !important; flex-wrap:wrap !important; width:100% !important;';
    chipsWrap.innerHTML = '<span class="dd-chips__loading">都道府県を選択してください</span>';
    dateField.appendChild(dateLabel);
    dateField.appendChild(chipsWrap);
    wrap.appendChild(dateField);

    // 時間帯
    var timeField = document.createElement('div');
    timeField.className = 'dd-picker__field';
    timeField.style.cssText = 'display:flex !important; flex-direction:column !important; width:100% !important;';
    var timeLabel = document.createElement('label');
    timeLabel.textContent = '配送希望時間帯';
    var timeSelect = document.createElement('select');
    timeSelect.className = 'dd-drawer-time';
    TIME_SLOTS.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      timeSelect.appendChild(opt);
    });
    timeField.appendChild(timeLabel);
    timeField.appendChild(timeSelect);
    wrap.appendChild(timeField);

    var status = document.createElement('p');
    status.className = 'dd-picker__status dd-drawer-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    wrap.appendChild(status);

    return wrap;
  }

  function wireWidget(root, cartAttrs) {
    cartAttrs = cartAttrs || {};
    var prefSelect = root.querySelector('.dd-drawer-pref');
    var chipsWrap = root.querySelector('.dd-drawer-chips');
    var timeSelect = root.querySelector('.dd-drawer-time');
    var status = root.querySelector('.dd-drawer-status');

    var savedDateSlash = cartAttrs.delivery_date || '';
    var savedPref = cartAttrs.shipping_prefecture || window.__ddCustomerProvince || '';
    if (cartAttrs.delivery_time) timeSelect.value = cartAttrs.delivery_time;
    if (savedPref) prefSelect.value = savedPref;

    function setStatus(message, state) {
      status.textContent = message || '';
      if (state) status.setAttribute('data-state', state); else status.removeAttribute('data-state');
    }

    function selectChip(button, dateObj) {
      Array.prototype.forEach.call(chipsWrap.querySelectorAll('.dd-chip'), function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      button.setAttribute('aria-pressed', 'true');
      setStatus('保存中…', 'saving');
      Core.saveToCart({
        delivery_date: Core.slash(dateObj),
        delivery_time: timeSelect.value,
        shipping_prefecture: prefSelect.value
      }).then(function (res) {
        if (!res.ok) throw new Error('failed');
        savedDateSlash = Core.slash(dateObj);
        setStatus('配送希望日時を保存しました。', 'success');
      }).catch(function () {
        setStatus('保存に失敗しました。もう一度お試しください。', 'error');
      });
    }

    function renderChips() {
      if (!prefSelect.value) {
        chipsWrap.innerHTML = '<span class="dd-chips__loading">都道府県を選択してください</span>';
        return;
      }
      var candidates = Core.buildCandidates(Core.currentLeadDaysFor(prefSelect.value));
      var openDays = candidates.filter(function (c) { return !c.closed; });
      chipsWrap.innerHTML = '';

      if (!openDays.length) {
        setStatus('表示期間内に選択可能な日がありません。恐れ入りますが日を改めてご確認ください。', 'error');
      }

      openDays.forEach(function (c) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dd-chip';
        btn.style.cssText = 'display:flex !important; flex-direction:column !important; width:auto !important;';
        btn.setAttribute('aria-pressed', (Core.slash(c.date) === savedDateSlash) ? 'true' : 'false');
        var md = document.createElement('span');
        md.textContent = (c.date.getUTCMonth() + 1) + '/' + c.date.getUTCDate();
        var wd = document.createElement('span');
        wd.className = 'dd-chip__wd';
        wd.textContent = Core.WEEKDAY_LABEL[c.date.getUTCDay()];
        btn.appendChild(md);
        btn.appendChild(wd);
        btn.addEventListener('click', function () { selectChip(btn, c.date); });
        chipsWrap.appendChild(btn);
      });
    }

    prefSelect.addEventListener('change', renderChips);
    timeSelect.addEventListener('change', function () {
      if (savedDateSlash) {
        setStatus('保存中…', 'saving');
        Core.saveToCart({ delivery_time: timeSelect.value, shipping_prefecture: prefSelect.value })
          .then(function () { setStatus('配送希望日時を保存しました。', 'success'); });
      }
    });

    Core.ready.then(renderChips);
  }

  function ensureInjected() {
    var anchors = findAnchors();
    anchors.forEach(function (anchorEl) {
      if (anchorEl.dataset.ddProcessed === 'true') return;
      anchorEl.dataset.ddProcessed = 'true'; // 同時発火での二重挿入を防ぐため即座にマーク

      Core.cartIsIneligibleForDelivery().then(function (shouldHide) {
        if (shouldHide) return; // ネコポス等の対象商品がある場合は差し込まない

        var shell = buildWidgetShell();
        anchorEl.insertAdjacentElement('afterend', shell);

        Core.currentCartAttributes().then(function (cart) {
          wireWidget(shell, cart.attributes || {});
        }).catch(function () {
          wireWidget(shell, {});
        });
      });
    });
  }

  var scheduled = false;
  function scheduleCheck() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      ensureInjected();
    });
  }

  var observer = new MutationObserver(scheduleCheck);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.body) {
    ensureInjected();
  } else {
    document.addEventListener('DOMContentLoaded', ensureInjected);
  }
})();